exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".intro-layer[data-v-07aa0740]{display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;bottom:0;left:0;right:0;z-index:100;background-color:rgba(255,99,71,.9);color:#fff}.intro-layer.fade-enter-active[data-v-07aa0740],.intro-layer.fade-leave-active[data-v-07aa0740]{transition:opacity 1s ease}.intro-layer.fade-enter[data-v-07aa0740],.intro-layer.fade-leave-to[data-v-07aa0740]{opacity:0}.intro-layer-text[data-v-07aa0740]{display:block;width:240px;margin:0 auto;text-align:left;line-height:1.4}.button-wrap[data-v-07aa0740]{width:240px;margin:0 auto;margin-top:40px}.button[data-v-07aa0740]{-webkit-appearance:none;display:block;box-sizing:border-box;width:100%;padding:5px;border-radius:3px;border:1px solid hsla(0,0%,100%,.8);background-color:transparent;color:#fff;font-size:14px}.button~.button[data-v-07aa0740]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07aa0740","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/introLayer.vue
// module id = 20
// module chunks = 0